import React, { Component } from 'react';
import Header from '../layout/Header';

export class Error extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showContent: false,
        };
    }

    componentDidMount() {
        this.timer = setTimeout(() => {
            this.setState({ showContent: true });
        }, 1000);
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    render() {
        if (!this.state.showContent) {
            // Loader HTML
            return (
                <div id="preloader">
                    <div id="status">&nbsp;</div>
                </div>
            );
        }

        return (
            <div className="site-main">
                <Header />
                <section className="error-404">
                    <div className="container-xl">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="ttm-big-icon ttm-textcolor-skincolor">
                                    <i className="far fa-thumbs-down" />
                                </div>
                                <header className="page-header">
                                    <h1 className="page-title">404 ERROR</h1>
                                </header>
                                <div className="page-content">
                                    <p>This page may have been moved or deleted. Be sure to check your spelling.</p>
                                </div>
                                <a
                                    className="ttm-btn ttm-btn-size-md ttm-bgcolor-skincolor mb-15"
                                    href={process.env.PUBLIC_URL + '/'}
                                >
                                    Back To Home
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Error;
